import { simpleAjaxDispatch } from './http';

export function fetchWebhooks(organizationId) {
  return simpleAjaxDispatch(
    `/webhooks?organization_id=${organizationId}`,
    'fetchWebhooks',
  );
}

export function fetchWebhookLogs(webhookId) {
  return simpleAjaxDispatch(
    `/webhooks/${webhookId}/events`,
    'fetchWebhookLogs',
    { responseSnake: false }, // de-snake messes with headers
  );
}

export function getWebhook(webhookId) {
  return simpleAjaxDispatch(`/webhooks/${webhookId}`, 'getWebhook');
}

export function addWebhook(json) {
  return simpleAjaxDispatch('/webhooks', 'addWebhook', {
    method: 'POST',
    json,
  });
}

export function deleteWebhook(webhookId) {
  return simpleAjaxDispatch(`/webhooks/${webhookId}`, 'deleteWebhook', {
    method: 'DELETE',
  });
}

export function patchWebhook(webhookId, json) {
  return simpleAjaxDispatch(`/webhooks/${webhookId}`, 'patchWebhook', {
    method: 'PATCH',
    json,
    meta: { webhookId },
  });
}

export function triggerWebhook(
  accreditationId,
  organizationId,
  webhookIds = null,
) {
  return simpleAjaxDispatch(
    '/accreditations/trigger-webhooks',
    'triggerWebhook',
    {
      method: 'POST',
      json: {
        accreditation_id: accreditationId,
        organization_id: organizationId,
        webhook_ids: webhookIds,
      },
    },
  );
}

export function triggerWebhookBulk(
  accreditationIds,
  organizationId,
  webhookIds = null,
) {
  return simpleAjaxDispatch(
    '/accreditations/trigger-webhooks/bulk',
    'triggerWebhookBulk',
    {
      method: 'POST',
      json: {
        accreditation_ids: accreditationIds,
        organization_id: organizationId,
        webhook_ids: webhookIds,
      },
    },
  );
}

export function searchAccreditationById(organizationId, accreditationId) {
  return simpleAjaxDispatch(
    `/accreditations?organization_id=${organizationId}&id=${accreditationId}&limit=50`,
    'searchAccreditationById',
  );
}

export function fetchAccreditationsByConstituent(
  organizationId,
  constituentId = null,
  constituentExternalId = null,
) {
  const params = new URLSearchParams({
    organization_id: organizationId,
  });

  if (constituentId) {
    params.append('constituent_id', constituentId);
  } else if (constituentExternalId) {
    params.append('constituent_external_id', constituentExternalId);
  }

  return simpleAjaxDispatch(
    `/accreditations/by-constituent?${params.toString()}`,
    'fetchAccreditationsByConstituent',
  );
}


/* export function addTag(json) {
  return simpleAjaxDispatch(
    '/tags', 'addTag',
    { method: 'POST', json }
  )
}
export function patchTag(tagId, json) {
  return simpleAjaxDispatch(
    `/tags/${tagId}`,
    'patchTag',
    { method: 'PATCH', json },
  )
}
export function deleteTag(tagId) {
  return simpleAjaxDispatch(
    `/tags/${tagId}`,
    'deleteTag',
    { method: 'DELETE' },
  )
}
*/
